import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchRecordAiFeedbacks,
  loadRecordAiFeedbacksCache,
  type RecordAiFeedbackRow,
} from '../../services/recordAiFeedbackService';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';

/** 학급 단위 AI 피드백 (행동특성·수업기록 쿼리와 같은 LS initialData + React Query 패턴) */
export function useRecordAiFeedbacksQuery(params: {
  workspaceId: string;
  gradeId: string;
  enabled?: boolean;
}): UseQueryResult<RecordAiFeedbackRow[]> {
  const { workspaceId, gradeId, enabled = true } = params;
  const cached = loadRecordAiFeedbacksCache(workspaceId, gradeId);
  return useQuery<RecordAiFeedbackRow[]>({
    queryKey: schoolKeys.recordAiFeedbacks(workspaceId, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(cached != null, cached ?? []),
    queryFn: () => fetchRecordAiFeedbacks(workspaceId, gradeId),
    // 모달(패널)이 열릴 때마다 백그라운드 재조회 — 캐시를 먼저 보여주고 최신값으로 갱신
    refetchOnMount: 'always',
    retry: false,
  });
}
